import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, Typography, DialogContent, DialogActions, Button, Box, } from "@mui/material";
import { useEffect } from "react";
import { between, stack2 } from "@ui/style/style";
import { PIconButton } from "@ui/components/buttons/PIconButton";
import { Icon } from "@iconify/react";
import { HInput } from "@ui/components/inputs/HInput";
import { useForm } from "react-hook-form";
import { Copy01 } from "@ui/icons/CustomIcons";
import { useAppSelector } from "@application/store/useStore";
import { useTranslation } from "react-i18next";
export const InvitationAccessDialog = ({ isOpen, onClose, }) => {
    const { t } = useTranslation();
    const { publicAccessInfo } = useAppSelector((state) => state.event);
    const { control, reset } = useForm({
        defaultValues: {
            accessLink: "",
            publicPassword: "",
        },
    });
    useEffect(() => {
        if (publicAccessInfo) {
            reset({
                accessLink: publicAccessInfo.accessLink,
                publicPassword: publicAccessInfo.publicPassword,
            });
        }
    }, [publicAccessInfo, reset]);
    const handleCopyLink = async (value) => {
        await navigator.clipboard.writeText(value);
    };
    return (_jsxs(Dialog, { open: isOpen, onClose: onClose, fullWidth: true, maxWidth: "sm", "aria-labelledby": "InvitationAccessDialog", children: [_jsxs(DialogTitle, { component: "div", sx: { ...between }, id: "InvitationAccessDialog", children: [_jsx(Typography, { variant: "h5", color: "text.primary", children: t("admin.familyFest.invitationAccess") }), _jsx(PIconButton, { size: "Xs", color: "#637381", border: "#919EAB29", onClick: onClose, children: _jsx(Icon, { icon: "mingcute:close-line", width: "24", height: "24" }) })] }), _jsx(DialogContent, { children: _jsxs(Box, { sx: { ...stack2, mt: 1 }, children: [_jsx(HInput, { label: t("admin.familyFest.magicLink"), control: control, name: "accessLink", disabled: true, rightIcon: _jsx(PIconButton, { size: "small", color: "#637381", border: "#919EAB29", onClick: () => handleCopyLink(publicAccessInfo?.accessLink || ""), children: _jsx(Copy01, {}) }) }), _jsx(HInput, { label: t("login.password"), control: control, name: "publicPassword", disabled: true, rightIcon: _jsx(PIconButton, { size: "small", color: "#637381", border: "#919EAB29", onClick: () => handleCopyLink(publicAccessInfo?.publicPassword || ""), children: _jsx(Copy01, {}) }) })] }) }), _jsx(DialogActions, { sx: { pb: 2, px: 3 }, children: _jsx(Button, { onClick: onClose, color: "inherit", variant: "outlined", children: t("common.cancel") }) })] }));
};
